import React from "react";
import { Card } from "antd";
import TeamLogo from "../../assets/icons/teammembers.svg";
import Appointments from "../../assets/icons/Appointments.svg";
import { Link } from "react-router-dom";
import Button from "./button";

const TeamMember = ({ type, count }) => {
  if (type === "team") {
    return (
      <Card className="border-2 shadow-md border-gray-200 sm:w-54.1 sm:h-11.4">
        <div className="flex sm:ml-1 sm:justify-start justify-center">
          <img src={TeamLogo} alt="Team Icon" className="mr-1" />
          <p className="font-bold text-primaryPurple">Team Members</p>
        </div>
        <div className="flex items-center justify-between sm:p-1 sm:flex-row flex-col">
          <p className="text-3xl m-1">{count}</p>
          <div className="flex">
            <Link to="/main/profile/manage-team">
              <Button
                title="Manage"
                className="bg-primaryPurple w-11.4 !h-3 !rounded-sm"
              />
            </Link>
          </div>
        </div>
      </Card>
    );
  } else if (type === "appointment") {
    return (
      <Card className="border-2 shadow-md border-gray-200 sm:w-27 sm:h-11.4">
        <div className="flex sm:ml-1 sm:justify-start justify-center">
          <img src={Appointments} alt="Team Icon" className="mr-1" />
          <p className="font-bold text-primaryPurple">Appointments</p>
        </div>
        <div className="flex sm:p-1 sm:flex-row flex-col items-center">
          <p className="text-3xl m-0.4">{count?.totalItems}</p>
          <div className="flex items-center"></div>
          <div className="flex items-center">
            <Link to="/main/orders/appointments">
              <Button
                title="Manage"
                className="m-0.4 bg-primaryPurple w-10 !h-3 !rounded-sm"
              />
            </Link>
          </div>
        </div>
      </Card>
    );
  }
};

export default TeamMember;
